import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initLocations({ commit }) {
    commit(types.SET_LOCATIONS_FOUND, null)
  },
  updatePreference({ commit }, data) {
    commit(types.UPDATE_PREFERENCE, data)
  },
  async getLocationTree({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLocationTree', () =>
      http.get(`firm/locationTree?id=${data.id}&firm=${data.firm}`)
    )
    commit(types.SET_LOCATION_TREE, r.data)
    return r.data
  },
  async getLocations({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getLocations', () =>
      http.get('firm/getFirms', {
        params: searchOptions
      })
    )
    commit(types.SET_LOCATIONS, r.data)
    return r.data
  },
  async getLocation({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getLocation', () =>
      http.get(`firm/firm?firm=${id}`)
    )
    commit(types.SET_LOCATION, r.data)
    return r.data
  },
  async saveLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveLocation', () =>
      http.post('firm/saveFirm', data)
    )
    return r.data
  },
  async updateLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateLocation', () =>
      http.post('firm/updateFirm', data)
    )
    return r.data
  },
  async removeLocation({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'removeLocation', () =>
      http.post('firm/removeFirm', data)
    )
    return r.data
  },
  async searchLocations({ commit, dispatch }, search) {
    let _firms = []
    if (search !== undefined && search !== null) {
      if (search.searchterm !== '') {
        let url = ''
        url = `firm/firmSearch/?firm=${search.firm}&searchterm=${search.searchterm}`
        let data = await http.get(url)
        if (data !== undefined && data !== null) {
          if (data.data !== undefined && data.data !== null) {
            for (let item of data.data) {
              let firm = {
                firm: item.firm,
                name: item.firmName
              }
              _firms.push(firm)
            }
          }
        }
        commit(types.SET_LOCATIONS_FOUND, _firms)
      }
    }
    return _firms
  },
  async getPreferences({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreferences', () =>
      http.get('firm/firmPreference', {
        params: data
      })
    )
    commit(types.SET_PREFERENCES, r.data)
    return r.data
  },
  async savePreferences({ commit, state, dispatch }) {
    state.preferences.forEach(element => {
      if (element.changed) {
        let data = {
          firm: element.firm,
          firmPreferenceName: element.name,
          preference: element.value,
          firmPreferenceCategory: element.type
        }
        http.post('firm/saveFirmPreference', data)
      }
    })
    commit(types.RESET_PREFERENCE_CHANGE)
  },
  async updateFirmSettings({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateFirmSettings', () =>
      http.post('firm/updateFirmSettings', data)
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/actions.js